import Swiper from "react-id-swiper";
import PropTypes from "prop-types";
import FaqHomeCategory from "app/pages/Faq/FaqHome/FaqHomeCategories/FaqHomeCategory";
import { Component } from "react";
import get from "lodash/get";
import "./FaqCategoriesSlider.scss";

class FaqCategoriesSlider extends Component {
	constructor(props) {
		super(props);
		this.state = { swiper: null, isEnd: false, isBeginning: true };
		this.updateSwiper = this.updateSwiper.bind(this);
		this.slidePrev = this.slidePrev.bind(this);
		this.slideNext = this.slideNext.bind(this);
		this.slideNextTransitionEnd = this.slideNextTransitionEnd.bind(this);
		this.slidePrevTransitionEnd = this.slidePrevTransitionEnd.bind(this);
	}

	updateSwiper(swiper) {
		this.setState({ swiper: swiper });
	}

	slidePrev() {
		this.state.swiper.slidePrev();
	}

	slideNext() {
		this.state.swiper.slideNext();
	}

	slideNextTransitionEnd() {}

	slidePrevTransitionEnd() {}

	render() {
		const { categories = [] } = this.props;

		const swiperParams = {
			shouldSwiperUpdate: true,
			slideChangeTransitionEnd: this.transitionEnd,
			getSwiper: this.updateSwiper,
			slidesPerView: 4,
			centerInsufficientSlides: true,
			spaceBetween: 21,
			on: {
				transitionEnd: () => {
					this.setState(state => {
						const isBeginning = get(state, "swiper.isBeginning");
						const isEnd = get(state, "swiper.isEnd");

						return {
							isBeginning: isBeginning,
							isEnd: isEnd,
						};
					});
				},
				slideNextTransitionEnd: this.slideNextTransitionEnd,
				slidePrevTransitionEnd: this.slidePrevTransitionEnd,
			},
		};

		const showArrows = categories.length > 4;

		return (
			<div className="faq-categories-slider">
				<Swiper {...swiperParams}>
					{categories.map(category => {
						return (
							<div key={category.id}>
								<FaqHomeCategory
									categoryName={category.name}
									categoryId={category.id}
									subCategories={category.subCategories}
									categoryPicture={category.image}
								/>
							</div>
						);
					})}
				</Swiper>
				<div className="faq-categories-slider__button faq-categories-slider__button--next">
					{showArrows && !this.state.isEnd && this.state.swiper && (
						<i className="icon icon--round-blue-next" onClick={this.slideNext} />
					)}
				</div>
				<div className="faq-categories-slider__button faq-categories-slider__button--previous">
					{showArrows && !this.state.isBeginning && this.state.swiper && (
						<i className="icon icon--round-blue-previous" onClick={this.slidePrev} />
					)}
				</div>
			</div>
		);
	}
}

FaqCategoriesSlider.propTypes = {
	categories: PropTypes.array,
};

export default FaqCategoriesSlider;
